const checkRoles = (roles: string[], organizationRoles: string[]) =>
  roles.some((role) => organizationRoles.includes(role));

export default checkRoles;
